const Don = {};

Don.indexSlider = {

  init: function () {
    let w = $(window).width();
    var $slider = $(".slider"),
         $slideBGs = $(".slide__bg"),
         diff = 0,
         curSlide = 0,
         numOfSlides = $(".slide").length-1,
         animating = false,
         animTime = 1000,
         autoSlideTimeout,
         autoSlideDelay = 4000,
         $pagination = $(".slider-pagi");

     function createBullets() {
       for (var i = 0; i < numOfSlides+1; i++) {
         var $li = $("<li class='slider-pagi__elem'></li>");
         $li.addClass("slider-pagi__elem-"+i).data("page", i);
         if (!i) $li.addClass("active");
         $pagination.append($li);
       }
     };

     createBullets();

     function manageControls() {
      if(w > 699) {
        $(".slider-control").removeClass("inactive");
        if (!curSlide) $(".slider-control.left").addClass("inactive");
        if (curSlide === numOfSlides) $(".slider-control.right").addClass("inactive");
      } else {
        $(".slider-controls-mobile").removeClass("inactive");
        if (!curSlide) $(".slider-controls-mobile.left-mobile").addClass("inactive");
        if (curSlide === numOfSlides) $(".slider-controls-mobile.right-mobile").addClass("inactive");
      }
     };

     function autoSlide() {
       autoSlideTimeout = setTimeout(function() {
         curSlide++;
         if (curSlide > numOfSlides) curSlide = 0;
         changeSlides();
       }, autoSlideDelay);
     };

     autoSlide();

     function changeSlides(instant) {
       if (!instant) {
         animating = true;
         manageControls();
         $slider.addClass("animating");
         $slider.css("top");
         $(".slide").removeClass("active");
         $(".slide-"+curSlide).addClass("active");
         setTimeout(function() {
           $slider.removeClass("animating");
           animating = false;
         }, animTime);
       }
       window.clearTimeout(autoSlideTimeout);
       $(".slider-pagi__elem").removeClass("active");
       $(".slider-pagi__elem-"+curSlide).addClass("active");
       $slider.css("transform", "translate3d("+ -curSlide*100 +"%,0,0)");
       $slideBGs.css("transform", "translate3d("+ curSlide*50 +"%,0,0)");
       diff = 0;
       autoSlide();
     }

     function navigateLeft() {
       if (animating) return;
       if (curSlide > 0) curSlide--;
       changeSlides();
     }

     function navigateRight() {
       if (animating) return;
       if (curSlide < numOfSlides) curSlide++;
       changeSlides();
     }

     $(document).on("mousedown touchstart", ".slider", function(e) {
       if (animating) return;
       window.clearTimeout(autoSlideTimeout);
       var startX = e.pageX || e.originalEvent.touches[0].pageX,
           winW = $(window).width();
       diff = 0;

       $(document).on("mousemove touchmove", function(e) {
         var x = e.pageX || e.originalEvent.touches[0].pageX;
         diff = (startX - x) / winW * 70;
         if ((!curSlide && diff < 0) || (curSlide === numOfSlides && diff > 0)) diff /= 2;
         $slider.css("transform", "translate3d("+ (-curSlide*100 - diff) +"%,0,0)");
         $slideBGs.css("transform", "translate3d("+ (curSlide*50 + diff/2) +"%,0,0)");
       });
     });

     $(document).on("mouseup touchend", function(e) {
       $(document).off("mousemove touchmove");
       if (animating) return;
       if (!diff) {
         changeSlides(true);
         return;
       }
       if (diff > -8 && diff < 8) {
         changeSlides();
         return;
       }
       if (diff <= -8) {
         navigateLeft();
       }
       if (diff >= 8) {
         navigateRight();
       }
     });

     $(document).on("click tap", ".slider-control", function() {
       if ($(this).hasClass("left")) {
         navigateLeft();
       } else {
         navigateRight();
       }
     });

     $(document).on("click tap", ".slider-controls-mobile", function() {
       if($(this).hasClass("left-mobile")) {
         navigateLeft();       } 
       if($(this).hasClass("right-mobile")) {
         navigateRight();
       }
     });

     $(document).on("click", ".slider-pagi__elem", function() {
       curSlide = $(this).data("page");
       changeSlides();
     });
  }
}

Don.showPopup = function () {

  let w = $(window).width();
  let flag = false;
  let $status = $('.gallery__counter__slide');
  let $slickElement = $('.gallery__slider');

  $('.js-show-popup').on("click tap", function () {
    if (w > 1160) {
      $('.popup.' + $(this).attr("rel")).fadeIn(500);
      $("body").append("<div id='overlay'></div>");
      $('#overlay').show().css({'filter': 'alpha(opacity=80)'});
      $('body').css('margin-right', (window.innerWidth - $('body').width()) + 'px');
      $('body').css('overflow', 'hidden');
      // $("body").animate({scrollTop: 0}, '300');

      if(!flag) {
        $('.gallery__slider').slick({
          arrows: true,
          dots: false,
          infinite: true,
          slide: '.gallery__slider__item',
          prevArrow: '<button class="gallery-button gallery-button--prev">\
            <svg class="gallery-arrow gallery-arrow--left">\
              <use xlink:href="#icon_arrow-right"></use></svg></button>',
          nextArrow: '<button class="gallery-button gallery-button--next">\
            <svg class="gallery-arrow gallery-arrow--right">\
              <use xlink:href="#icon_arrow-right"></use></svg></button>'
        });


        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
          let i = (currentSlide ? currentSlide : 0) + 1;
          $status.find('span').text(i);
        });

        flag = true;
      }

      let number = $(this).attr('data-number') - 1;
      $slickElement.slick('slickGoTo', number, true);

      return false;
    }
  });

  $('.js-reg-popup').on("click tap", function () {
    $('.popup.' + $(this).attr("rel")).fadeIn(500);
    $("body").append("<div id='overlay'></div>");
    $('#overlay').show().css({'filter': 'alpha(opacity=80)'});
    $('body').css('margin-right', (window.innerWidth - $('body').width()) + 'px');
    $('body').css('overflow', 'hidden');

    return false;
  });
};

Don.closePopup = function () {

  $('.js-close-popup').on("click tap", function (event) {

    event.preventDefault();

    $('.popup').fadeOut(200);
    $('#overlay').remove('#overlay');
    $('body').css('overflow', '');
    $('body').css('margin-right', '');

    return false;
  });
};

Don.animationBlocks = function () {
  let w = $(window).width();
  let px;

  if(w > 1160) {
    px = 700;
  } else {
    px = 900;
  }

  //Появление блоков снизу
  $(window).load(function() {
    $('.hidden-block').each(function(ind, val) {
      let blockPosition = $(val).offset().top;
      let windowPosition = $(window).scrollTop();
      if (blockPosition < windowPosition + px) {
        $(val).addClass('animated-block');
      }
    });
  });

  $(window).scroll(function() {
    $('.hidden-block').each(function(ind, val) {
      let windowPosition = $(window).scrollTop();
      let blockPosition = $(val).offset().top;
      if (blockPosition < windowPosition + px) {
        $(val).addClass('animated-block');
        if($(val).children('.stats__logo') && w >1160) {
          $(val).find('.stats__logo').addClass('for-logo-rect-blue');
        }
      }
    });
  });

  //Появление карт справа(новости, объекты)
  $(window).load(function() {
    $('.hidden-card').each(function(ind, val) {
      let blockPosition = $(val).offset().top;
      let windowPosition = $(window).scrollTop();
      if (blockPosition < windowPosition + px) {
        $(val).addClass('animated-card');
      }
    });
  });

  $(window).scroll(function() {
    $('.hidden-card').each(function(ind, val) {
      let windowPosition = $(window).scrollTop();
      let blockPosition = $(val).offset().top;
      if (blockPosition < windowPosition + px) {
        $(val).addClass('animated-card');
      }
    });
  });

  //Выезжание текстов вверх
  const SPACE1 = 900;
  const SPACE2 = 700;
  const SPACE3 = 500;

  $(window).load(function() {
    $('.title-up').each(function(ind, val) {
      let blockPosition = $(val).offset().top;
      let windowPosition = $(window).scrollTop();
      if($(val).hasClass('space1')) {
        if (blockPosition < windowPosition + SPACE1) {
          $(val).find('span').addClass('go-up');
        }
      }
      if($(val).hasClass('space2')) {
        if (blockPosition < windowPosition + SPACE2) {
          $(val).find('span').addClass('go-up');
        }
      }
    });
  });

  $(window).scroll(function() {
    $('.title-up').each(function(ind, val) {
      let windowPosition = $(window).scrollTop();
      let blockPosition = $(val).offset().top;
      if($(val).hasClass('space1')) {
        if (blockPosition < windowPosition + SPACE1) {
          $(val).find('span').addClass('go-up');
        }
      }
      if($(val).hasClass('space2')) {
        if (blockPosition < windowPosition + SPACE2) {
          $(val).find('span').addClass('go-up');
        }
      }
    });
  });
};

Don.sliderArrows = function () {
  $(".slider-control.right").hover(
    function() {
      $(this).prev().css('display','none');
    }, function() {
      $(this).prev().removeAttr('style');
    }
  );

  $(".slider-control.left").hover(
    function() {
      $(this).next().css('display','none');
    }, function() {
      $(this).next().removeAttr('style');
    }
  );
};

Don.openMainMenu = function () {
  $('.js-burger').on('click' , function() {
    if($(this).hasClass('open-menu')) {
      $('body').removeClass('stop-scrolling');
      $('.header-mobile__menu').fadeOut();
      $(this).removeClass('open-menu');
    } else {
      $('.header-mobile__menu').fadeIn();
      $(this).addClass('open-menu');
      $('body').addClass('stop-scrolling');
    }
  });

  $('.js-burger-blue').on('click' , function() {
    if($(this).hasClass('open-menu')) {
      $('body').removeClass('stop-scrolling');
      $('.blue-header-mobile__menu').fadeOut();
      $(this).removeClass('open-menu');
    } else {
      $('.blue-header-mobile__menu').fadeIn();
      $(this).addClass('open-menu');
      $('body').addClass('stop-scrolling');
    }
  });
};

Don.openSubmenu = function () {
  $('.js-submenu').on('click' , function() {
    if($(this).hasClass('open-submenu')) {
      $(this).next().slideUp('slow');
      $(this).removeClass('open-submenu');
    } else {
      $(this).next().slideDown('slow');
      $(this).addClass('open-submenu');
    }
  });
};

Don.flySubmenu = function () {
  let w = $(window).width();

  if($('.js-fly-menu').length) {
    if (w > 960) {
      let beforeTop = $('.js-fly-menu').offset().top;
      $(window).scroll(function () {
        let top = $(document).scrollTop();
        if(top >= beforeTop - 50) {
          $('.js-fly-menu').css({
            'position': 'fixed',
            'top': '50px'
          });
        } else {
          $('.js-fly-menu').removeAttr('style');
        }
      });
    }
  }
};

Don.validationRegAuth = function () {

  $('input').change(function () {
    if ($(this).val()) {
      $(this).addClass('has_value');
    } else {
      $(this).removeClass('has_value');
    }
  });

  $('textarea').change(function () {
    if ($(this).val()) {
      $(this).addClass('has_value');
    } else {
      $(this).removeClass('has_value');
    }
  });

  $('#email-auth, #password-auth').focus(function () {
    $('.error-enter').text('');
  });

  $('#email').focus(function () {
    $('.error-reg-email').text('');
  });

  $('.js-registration').on('click', function() {
    $('.authorization__img').addClass('go-hide');
    setTimeout(function() { 
      $('.authorization').fadeOut('slow', function () {
         $('.registration').fadeIn('slow');
         $('.authorization__img').removeClass('go-hide');
      });
    }, 1000);
  });

  $('.js-enter').on('click', function() {
    $('.registration').fadeOut('slow', function () {
      $('.authorization').fadeIn('slow');
    });
  });

  $("#phone").mask("+7 (999) 999-99-99", {autoclear: 1});

  $.extend($.validator.messages, {
    email: "Введите корректный e-mail"
  });

  let validatorEnter = $("#authorization-form").validate({
    rules : {
      email: {
        required: true,
        email: true
      },
      password: {
        required: true,
        minlength: 6
      }
    },
    messages: {
      email: {
        required: 'Поле обязательно для заполнения',
        email: 'Введите корректный e-mail'
      },
      password: {
        required: 'Поле обязательно для заполнения',
        minlength: 'Минимальное кол-во символов 6'
      }
    },
    errorPlacement: function(error, element) {
      if (element.attr("name") == "email" || element.attr("name") == "password"  ) {
        error.insertAfter($(element).next());
      } else {
        error.insertAfter($(element).next());
      }
    },
    submitHandler: function(form) {

      let options = { target: null, dataType: 'json', type: 'POST' };

      options.beforeSubmit = function (formData, jqForm, options) {
        $('#enter').attr('disabled','disabled');
      };

      options.success = function (response, status, xhr, jqForm) {
        if(status == 'success') {
          window.location.replace(`/${window.LOCALE}/tenders/list`);
        }
      };

      options.error = function (xhr, textStatus, errorThrown) {
        if(xhr.responseJSON.email = "Имя пользователя и пароль не совпадают.") {
          $('.error-enter').text('Имя пользователя и пароль не совпадают');
        }
        $('#enter').removeAttr('disabled');
      };

      $(form).ajaxSubmit(options);
    }
  });

  let validatorReg = $("#registration-form").validate({
    rules : {
      full_name: {
        required: true
      },
      email: {
        required: true,
        email: true
      },
      password: {
        required: true,
        minlength: 6,
      },
      password_confirmation: {
        required: true,
        equalTo: '#password'
      },
      phone: {
        required: true
      },
      company_name: {
        required: true
      },
      address: {
        required: true
      },
      company_inn: {
        required: true,
        digits: true
      }
    },
    messages: {
      full_name: {
        required: 'Поле обязательно для заполнения'
      },
      email: {
        required: 'Поле обязательно для заполнения',
        email: 'Введите корректный e-mail'
      },
      password: {
        required: 'Поле обязательно для заполнения',
        minlength: 'Минимальное кол-во символов 6'
      },
      password_confirmation: {
        required: 'Поле обязательно для заполнения',
        equalTo: "Пароли не совпадают"
      },
      phone: {
        required: 'Поле обязательно для заполнения'
      },
      company_name: {
        required: 'Поле обязательно для заполнения'
      },
      address: {
        required: 'Поле обязательно для заполнения'
      },
      company_inn: {
        required: 'Поле обязательно для заполнения',
        digits: 'Поле содержить только цифры'
      }
    },
    errorPlacement: function(error, element) {
      if (element.attr("name") == "full_name" || element.attr("name") == "email" || element.attr("name") == "password" 
        || element.attr("name") == "password_confirmation" || element.attr("name") == "phone" || element.attr("name") == "company_name"
        || element.attr("name") == "address" || element.attr("name") == "company_inn") {
        error.insertAfter($(element).next());
      } else {
        error.insertAfter($(element).next());
      }
    },
    submitHandler: function(form) {

      let options = { target: null, dataType: 'json', type: 'POST' };

      options.beforeSubmit = function (formData, jqForm, options) {
        $('#reg-submit').attr('disabled','disabled');
      };

      options.success = function (response, status, xhr, jqForm) {
        if(status == 'success') {
          $('.registration').fadeOut('fast');
          $('.registration-success').fadeIn('slow');
        }
      };

      options.error = function (xhr, textStatus, errorThrown) {
        if(xhr.responseJSON.email = "Такое значение поля email уже существует.") {
          $('.error-reg-email').text('Пользователь с такой почтой уже существует');
        }
        $('#reg-submit').removeAttr('disabled');
      };

      $(form).ajaxSubmit(options);
    }
  });

  let allFiles = [];

  Dropzone.autoDiscover = false;
  $("#dropzone").dropzone({
    url: '/upload_file',
    paramName: 'files',
    addRemoveLinks: false,
    dictDefaultMessage: 'Перетащите сюда файлы, или <span class="load">загрузите<span>',

    success: function success(file, response) {
      let fileSingle = {
        'id': response.file.id,
        'src': response.file.src,
        'size':response.file.size
      };

      allFiles.push(fileSingle);

      $('#files').val(JSON.stringify(allFiles));
    },
    removedfile: function removedfile(file) {
      console.log(file);
    }
  });

  let validatorOffer = $("#offer-form").validate({
    rules : {
      price: {
        required: true
      },
      description: {
        required: true
      }
    },
    messages: {
      price: {
        required: 'Поле обязательно для заполнения'
      },
      description: {
        required: 'Поле обязательно для заполнения'
      }
    },
    errorPlacement: function(error, element) {
      if (element.attr("name") == "price" || element.attr("name") == "description") {
        error.insertAfter($(element).next());
      } else {
        error.insertAfter($(element).next());
      }
    },
    submitHandler: function(form) {

      let options = { target: null, dataType: 'json', type: 'POST' };

      options.beforeSubmit = function (formData, jqForm, options) {
        $('#send_offer').attr('disabled','disabled');
      };

      options.success = function (response, status, xhr, jqForm) {
        if(status == 'success') {
          $('.form-for-offer__form').fadeOut('fast');
          $('.form-for-offer__success').fadeIn('slow');
        }
      };

      options.error = function (xhr, textStatus, errorThrown) {
        $('#send_offer').removeAttr('disabled');
      };
      $(form).ajaxSubmit(options);
    }
  });
};

Don.openSelect = function () {
  //Открытие и закрытие первого селекта
  $('.js-item-type').on('click tap' , function() {
    if($(this).hasClass('select-open')) {
      $(this).next('.all-value').fadeOut('400');
      $(this).removeClass('select-open');
      $(this).parents('.filter-tender__item').removeClass('active-white');
    } else {
      $(this).next('.all-value').fadeIn('400');
      let val = $(this);
      setTimeout(() => {
        $(val).addClass('select-open')
      }, 300);
      $(this).parents('.filter-tender__item').addClass('active-white');
      $('.js-item-object').next('.all-value').fadeOut('400');
      $('.js-item-object').removeClass('select-open');
      $('.js-item-object').parents('.filter-tender__item').removeClass('active-white');
    }
  });

  //Выбор пункта в первом селекте
  $('.js-type').on('click tap' , function() {

    let $element = $(this).parent().prev('.only-value').find('.only-choose-value');
    let ID = $(this).parent().prev('.only-value').find('.only-choose-value').attr('data-id');

    let curID = +$(this).attr('data-id');
    let curText = $(this).text();

    if(curID !== ID) {
      $($element).text(curText);
      $($element).attr('data-id', curID);

      //Обновляем второй селект
      $('.objects').find('.js-object').each(function() {
        let objectID = +$(this).attr('data-id');
        if(curID == 0) {
          $(this).removeClass('hidden');
        } else { 
          $(this).removeClass('hidden');
          if(objectID != curID) {
            $(this).addClass('hidden');
          }
        }
      });

      //Обновляем тендеры
      $('.tenders__item').each(function() {
        let tenderType = +$(this).attr('data-type');
        if(curID == 0) {
          $(this).removeClass('hidden');
        } else { 
          $(this).removeClass('hidden');
          if(tenderType != curID) {
            $(this).addClass('hidden');
          }
        }
      });
    }
    $('.js-item-type').next('.all-value').fadeOut('400');
    $('.js-item-type').removeClass('select-open');
    $('.js-item-type').parents('.filter-tender__item').removeClass('active-white');
  });

  //Открытие и закрытие второго селекта
  $('.js-item-object').on('click tap' , function() {
    if($(this).hasClass('select-open')) {
      $(this).next('.all-value').fadeOut('400');
      $(this).removeClass('select-open');
      $(this).parents('.filter-tender__item').removeClass('active-white');
    } else {
      $(this).next('.all-value').fadeIn('400');
      let val = $(this);
      setTimeout(() => {
        $(val).addClass('select-open')
      }, 300);
      $(this).parents('.filter-tender__item').addClass('active-white');
      $('.js-item-type').next('.all-value').fadeOut('400');
      $('.js-item-type').removeClass('select-open');
      $('.js-item-type').parents('.filter-tender__item').removeClass('active-white');
    }
  });

  //Выбор пункта во втором селекте
  $('.js-object').on('click tap' , function() {

    let $element = $(this).parent().prev('.only-value').find('.only-choose-value');
    let ID = $(this).parent().prev('.only-value').find('.only-choose-value').attr('data-id');

    let curID = +$(this).attr('data-id');
    let curText = $(this).text();

    let curObject = +$(this).attr('data-object');

    if(curID !== ID) {
      $($element).text(curText);
      $($element).attr('data-id', curID);
    }

    //Обновляем тендеры
    $('.tenders__item').each(function() {
      let tenderObject = +$(this).attr('data-object');
      if(curID == 0) {
        $(this).removeClass('hidden');
      } else { 
        $(this).removeClass('hidden');
        if(tenderObject != curObject) {
          $(this).addClass('hidden');
        }
      }
    });

    $('.js-item-object').next('.all-value').fadeOut('400');
    $('.js-item-object').removeClass('select-open');
    $('.js-item-object').parents('.filter-tender__item').removeClass('active-white');
  });

  $('body').on('click', function() {
    if($('.js-item-type').length && $('.js-item-object').length) {
      if($('.js-item-type').hasClass('select-open')) {
        $('.js-item-type').next('.all-value').fadeOut('400');
        $('.js-item-type').removeClass('select-open');
        $('.js-item-type').parents('.filter-tender__item').removeClass('active-white');
      }
      if($('.js-item-object').hasClass('select-open')) {
        $('.js-item-object').next('.all-value').fadeOut('400');
        $('.js-item-object').removeClass('select-open');
        $('.js-item-object').parents('.filter-tender__item').removeClass('active-white');
      }
    }
  });
};

Don.resizeTextarea = function() {

    function observe(element, event, handler) {
        element.addEventListener(event, handler, false);
    };

    return function init() {
        var text = document.getElementById('description');

        function resize () {
            text.style.height = 'auto';
            text.style.height = text.scrollHeight + 'px';
        }

        function delayedResize () {
            window.setTimeout(resize, 0);
        }

        observe(text, 'change',  resize);
        observe(text, 'cut',     delayedResize);
        observe(text, 'paste',   delayedResize);
        observe(text, 'drop',    delayedResize);
        observe(text, 'keydown', delayedResize);

        $('#description').on('click', delayedResize);

        text.focus();
        text.select();
    };
};

Don.videoPlay = function() {
    if($('.js-play-video').length) {
      $('.js-play-video').on('click', function() {
        $('#news-video')[0].play();
        $(this).fadeOut('slow');
        $('.article-video__bg').fadeOut('slow');
      });

      $("#news-video").on("ended", function (){
        $('.article-video__bg').fadeIn('slow');
        $('.js-play-video').fadeIn('slow');
      });
    }
};

// Don.PopupAnketa = function () {

//   $('.send-anketa').on("click tap", function () {
//     $('.popup.' + $(this).attr("rel")).fadeIn(500);
//     $("body").append("<div id='overlay'></div>");
//     $('#overlay').show().css({'filter': 'alpha(opacity=80)'});
//     $('body').css('margin-right', (window.innerWidth - $('body').width()) + 'px');
//     $('body').css('overflow', 'hidden');

//     return false;
//   });

//   $("#anketaPhone").mask("+7 (999) 999-99-99", {autoclear: 1});

//   let anketa = [];

//   Dropzone.autoDiscover = false;
//   $("#anketa-dropzone").dropzone({
//     url: '/upload_file',
//     paramName: 'files',
//     maxFiles: 1,
//     addRemoveLinks: false,
//     dictDefaultMessage: 'Перетащите сюда анкету, или <span class="load">загрузите<span>',

//     success: function success(file, response) {
//       console.log(file, response);
//       if($('#anketaFile-error').length) {
//         $('#anketaFile-error').remove();
//       }

//       $('#anketaFile').val(123);

//       // $('#anketaFile').val('123');
//       // let fileAnketa = {
//       //   'id': response.file.id,
//       //   'src': response.file.src,
//       //   'size':response.file.size
//       // };

//       // anketa.push(fileAnketa);

//       // $('#anketaFile').val(JSON.stringify(fileAnkate));
//     }
//   });

//   let validatorAnketa = $("#anketa-form").validate({
//     ignore: '',
//     rules : {
//       anketaName: {
//         required: true
//       },
//       anketaPhone: {
//         required: true
//       },
//       anketaFile: {
//         required: true
//       }
//     },
//     messages: {
//       anketaName: {
//         required: 'Поле обязательно для заполнения'
//       },
//       anketaPhone: {
//         required: 'Поле обязательно для заполнения'
//       },
//       anketaFile: {
//         required: 'Загрузите вашу анкету'
//       }
//     },
//     errorPlacement: function(error, element) {
//       if (element.attr("name") == "anketaName" || element.attr("name") == "anketaPhone") {
//         error.insertAfter($(element).next());
//       } else {
//         error.insertAfter($(element).next());
//       }
//       if (element.attr("name") == "anketaFile") {
//         error.insertAfter($('.anketa-form__form__file').next());
//       }
//     },
//     submitHandler: function(form) {

//       let options = { target: null, dataType: 'json', type: 'POST' };

//       options.beforeSubmit = function (formData, jqForm, options) {
//         $('.js-send-anketa').attr('disabled','disabled');
//       };

//       options.success = function (response, status, xhr, jqForm) {
//         // if(status == 'success') {
//         //   $('.form-for-offer__form').fadeOut('fast');
//         //   $('.form-for-offer__success').fadeIn('slow');
//         // }
//       };

//       options.error = function (xhr, textStatus, errorThrown) {
//         $('.js-send-anketa').removeAttr('disabled');
//       };
//       $(form).ajaxSubmit(options);
//     }
//   });

// };

Don.servicesTitleClamp = function () {

    if($('.service-item__title').length) {
        $('.service-item__title').each(function(index, element) {
            $clamp(element, { clamp: 4 });
        });
    }
};

$(document).ready(function() {
  Don.indexSlider.init();
  Don.showPopup();
  Don.closePopup();
  Don.animationBlocks();
  Don.sliderArrows();
  Don.openMainMenu();
  Don.openSubmenu();
  Don.flySubmenu();
  //Don.regPopup();
  Don.validationRegAuth();
  Don.openSelect();
  // Don.PopupAnketa();
  Don.servicesTitleClamp();

  if($('.textarea-block').length) {
    Don.resizeTextarea()();
  }

  Don.videoPlay();

  //Для мобильного меню(на айфоне из-за плашки не видно блока в самом низу меню)
  let iOS1 = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if(iOS1) {
    if($('.header-mobile__menu__main').length) {
      $('.header-mobile__menu__main').css('padding-bottom', '50px');
    }
    if($('.blue-header-mobile__menu__main').length) {
      $('.blue-header-mobile__menu__main').css('padding-bottom', '50px');
    }
  }
});